//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layer.js";
import "../no/Object.js";
import "../no/BasePart.js";
let d=[[[0,"WorkLayer",1,0]],[[["state_array","fitAll"],"ChangeStates",{},2,0],[["state_array"],"ChangeStatesNorefit",{},1,0],[[],"GetStates",{R_:{state_collection:"Layer.StateCollection"}},0,0],[["state_collection","fitAll"],"SetStates",{},2,0],[["state_collection"],"SetStatesNorefit",{},1,0],[["layer","state"],"SetStateNorefit",{},2,0],[["layer","state","fitAll"],"SetState",{},3,0],[["layer"],"GetState",{R_:{state:''}},1,0],[["new_layer","object_array"],"MoveDisplayableObjects",{},2,0],[["new_layer","object_array"],"ApplyMoveToLayerToOwningParts",{},2,0],[["layer","n_objects"],"GetAllObjectsOnLayer",{R_:{objects:"NXObject[]"}},1,0],[["new_layer","object_array"],"CopyObjects",{},2,0],[["view","n_layers","state_array"],"GetVisibilitiesInView",{},1,0],[["view","state_array","do_update"],"SetObjectsVisibilityOnLayer",{},3,0],[["view"],"ResetViewVisibilityToGlobal",{},1,0],[["n_layers"],"GetLayersWithObjects",{R_:{layers:""}},0,0]],[]];
SPLM.Layer.LayerManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Layer.LayerManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;